"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _textItem = _interopRequireDefault(require("./text-item"));
var _index = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _index2 = _interopRequireDefault(require("../../../elements/other/headline-lockup/index"));
var _text = _interopRequireDefault(require("@ux/text"));
/**
 * Local Imports
 */

const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-h9om7dh"
});
const List = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "List",
  class: "pl-l1huv1z4",
  vars: {
    "l1huv1z4-1": [({
      isHeading
    }) => isHeading ? '1rem' : '0']
  }
});
const CtaContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CtaContainer",
  class: "pl-coi5d1r"
});

/**
 * ListItem Component.
 *
 * @param {Object} props React props
 * @param {String} props.id Identifier for the list item
 * @param {String} props.title Title of List Item
 * @param {String} props.cta Button
 * @param {Array} props.items Array of List Items
 * @param {Boolean} props.inverted Invert Text Color
 * @param {String} props.heading Heading of List Item
 * @param {String} props.description Description of List Item
 * @param {String} props.headlineSize Accessible heading props
 * @param {String} props.headlineTag Accessible heading props
 * @param {String} props.partial Theme partials
 * @returns {React.ReactElement} ListItem Component
 * @public
 */

function ListItem({
  id,
  title,
  cta,
  items,
  inverted = false,
  partial,
  heading,
  description,
  headlineSize,
  headlineTag
}) {
  return /*#__PURE__*/_react.default.createElement(List, {
    id: `id-${id}`,
    "data-cy": "list-item",
    isHeading: heading
  }, cta && /*#__PURE__*/_react.default.createElement(CtaContainer, null, /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: "button-set",
    ctas: [{
      ...cta,
      design: 'inline',
      size: 'small',
      partial: partial || (inverted ? 'dark1' : '')
    }]
  })), (heading || description) && /*#__PURE__*/_react.default.createElement(HeadlineWrapper, {
    "data-cy": "category-headline"
  }, /*#__PURE__*/_react.default.createElement(_index2.default, {
    heading: heading,
    description: description,
    headlineSize: headlineSize ?? 'h5',
    headlineTag: headlineTag ?? 'h2',
    textAlign: "start"
  })), title && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    text: title,
    "data-cy": "paragraph",
    className: "text-title"
  }), items?.map((item, idx) => {
    return /*#__PURE__*/_react.default.createElement(_textItem.default, (0, _extends2.default)({
      key: idx
    }, item));
  }));
}
var _default = exports.default = ListItem;
ListItem.propTypes = {
  id: _propTypes.default.string,
  heading: _propTypes.default.string,
  description: _propTypes.default.string,
  title: _propTypes.default.string,
  cta: _propTypes.default.shape(_index.default.propTypes),
  items: _propTypes.default.arrayOf(_propTypes.default.shape(_textItem.default.propTypes)),
  inverted: _propTypes.default.bool,
  partial: _propTypes.default.string,
  headlineSize: _propTypes.default.string,
  headlineTag: _propTypes.default.string
};